import { render, staticRenderFns } from "./CategoryFull.vue?vue&type=template&id=368033b8&scoped=true&"
import script from "./CategoryFull.vue?vue&type=script&lang=js&"
export * from "./CategoryFull.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFull.vue?vue&type=style&index=0&id=368033b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368033b8",
  null
  
)

export default component.exports